import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams,useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../../utils/api';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import BackButton from '../../components/BackButton';

const EditShift = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
const returnTo = location.state?.returnTo || '/dashboard';
  const token = localStorage.getItem('token');
  const [conflict, setConflict] = useState(null);
  const [clients, setClients] = useState([]);
  const [formData, setFormData] = useState({
    clientId: '',
    date: '',
    startTime: '',
    endTime: '',
    recurrence: 'none',
    title: '',
    allowOverlap: false
  });

  useEffect(() => {
    const fetchClientsAndShift = async () => {
      try {
        const [clientsRes, shiftRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/clients`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_BASE_URL}/api/shifts/${id}`, { headers: { Authorization: `Bearer ${token}` } })
        ]);

        setClients(clientsRes.data);
        const shift = shiftRes.data;
        setFormData({
          ...shift,
          allowOverlap: shift.allowOverlap || false,
          date: shift.date,
          startTime: shift.startTime.slice(0, 5),
          endTime: shift.endTime.slice(0, 5),
        });
      } catch {
        toast.error('Failed to load shift or clients');
      }
    };
    fetchClientsAndShift();
  }, [id, token]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleDateChange = (date) => {
    if (!date) return;
    setFormData(prev => ({ ...prev, date: dayjs(date).format('YYYY-MM-DD') }));
  };

  const handleTimeChange = (name, date) => {
    if (!date) return;
    const formatted = dayjs(date).format('HH:mm');
    setFormData(prev => ({ ...prev, [name]: formatted }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_BASE_URL}/api/shifts/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Shift updated successfully');
      
        if (returnTo === '/shifts/new') {
          navigate('/shifts/new');
        } else {
          navigate('/dashboard');
        }
      
      
    } catch (err) {
      if (err.response?.status === 409 && err.response.data?.conflicts) {
        setConflict(err.response.data.conflicts);
      } else {
        toast.error('Failed to book shift');
      }
      toast.error('Error updating shift');
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this shift?')) return;
    try {
      await axios.delete(`${API_BASE_URL}/api/shifts/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Shift deleted');
      navigate('/dashboard');
    } catch {
      toast.error('Failed to delete shift');
    }
  };
  const closeConflictPopup = () => setConflict(null);
  return (
    <div className="min-h-screen bg-[#0E0A1F] text-white p-6">
      <BackButton/>
      <div className="max-w-xl mx-auto bg-[#1C1235] p-6 rounded-xl space-y-4">
        <h2 className="text-xl font-bold">Edit Shift</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1 text-sm">Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="w-full p-3 rounded bg-[#2A1C4A] text-white"
            />
          </div>

          <div>
            <label className="block mb-1 text-sm">Client</label>
            <select
              name="clientId"
              value={formData.clientId}
              onChange={handleChange}
              required
              className="w-full p-3 rounded bg-[#2A1C4A] text-white"
            >
              <option value="">Select client</option>
              {clients.map((client) => (
                <option key={client.id} value={client.id}>{client.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block mb-1 text-sm">Date</label>
            <DatePicker
              selected={formData.date ? new Date(formData.date) : null}
              onChange={handleDateChange}
              dateFormat="dd/MM/yy"
              className="w-full p-3 rounded bg-[#2A1C4A] text-white border border-[#3B2D5F]"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </div>

          <div className="flex gap-4">
            <div className="flex-1">
              <label className="block mb-1 text-sm">Start Time</label>
              <DatePicker
                selected={formData.startTime ? dayjs(`2020-01-01T${formData.startTime}`).toDate() : null}
                onChange={(date) => handleTimeChange('startTime', date)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={5}
                timeCaption="Start Time"
                dateFormat="HH:mm"
                className="w-full p-3 rounded bg-[#2A1C4A] text-white"
              />
            </div>
            <div className="flex-1">
              <label className="block mb-1 text-sm">End Time</label>
              <DatePicker
                selected={formData.endTime ? dayjs(`2020-01-01T${formData.endTime}`).toDate() : null}
                onChange={(date) => handleTimeChange('endTime', date)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={5}
                timeCaption="End Time"
                dateFormat="HH:mm"
                className="w-full p-3 rounded bg-[#2A1C4A] text-white"
              />
            </div>
          </div>

          {/* <div>
            <label className="block mb-1 text-sm">Repeat</label>
            <select
              name="recurrence"
              value={formData.recurrence}
              onChange={handleChange}
              className="w-full p-3 rounded bg-[#2A1C4A] text-white"
            >
              <option value="none">None</option>
              <option value="weekly">Weekly</option>
              <option value="fortnightly">Fortnightly</option>
              <option value="monthly">Monthly</option>
            </select>
          </div> */}

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              name="allowOverlap"
              checked={formData.allowOverlap}
              onChange={handleChange}
              className="w-4 h-4"
            />
            <label className="text-sm">Allow overlapping shifts</label>
          </div>

          <div className="flex justify-between gap-4">
            <button
              type="submit"
              className="flex-1 py-3 bg-[#8F4EFF] hover:bg-purple-700 rounded font-semibold"
            >
              Update Shift
            </button>
            <button
              type="button"
              onClick={handleDelete}
              className="flex-1 py-3 bg-red-600 hover:bg-red-700 rounded font-semibold"
            >
              Delete Shift
            </button>
          </div>
        </form>
      </div>
      {/* Conflict Modal */}
      {conflict && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
          <div className="bg-white text-black p-6 rounded-xl max-w-lg w-full overflow-y-auto max-h-[80vh]">
            <h3 className="text-xl font-bold mb-4 text-center">Conflicting Shifts Detected</h3>

            {conflict.map((conflicts) => (
              <div key={conflicts.id} className="border-b border-gray-200 pb-3 mb-3 text-sm">
                {conflicts.title && (
                  <p className="mb-1"><strong>Title:</strong> {conflicts.title}</p>
                )}
                <p className="mb-1"><strong>Client:</strong> {conflicts.Client?.name}</p>
                <p className="mb-1"><strong>Time:</strong> {conflicts.startTime} - {conflicts.endTime}</p>
                {conflicts.recurrence !== 'none' && (
                  <p className="mb-1"><strong>Repeats:</strong> {conflicts.recurrence}</p>
                )}
                {/* <Link
                  to={`/shifts/${conflicts.id}/edit`}
                  className="inline-block mt-2 bg-blue-600 text-white text-xs px-4 py-1.5 rounded hover:bg-blue-700"
                >
                  View Shift
                </Link> */}

                  <Link
                    to={`/shifts/${conflicts.id}/edit`}
                    className="inline-block mt-2 bg-blue-600 text-white text-xs px-4 py-1.5 rounded hover:bg-blue-700"
                  >
                    View Shift
                  </Link>
              </div>
            ))}

            <button
              onClick={closeConflictPopup}
              className="w-full mt-2 bg-gray-600 text-white text-sm py-2 rounded hover:bg-gray-700"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditShift;
